import { css, Global, withTheme } from '@emotion/react'
import * as React from 'react'

const Globals = withTheme(({ theme }) => (
  <Global
    styles={css`
      .leshen-typography-h1[color='light'],
      .leshen-typography-h2[color='light'],
      .leshen-typography-h3[color='light'],
      .leshen-typography-h4[color='light'],
      .leshen-typography-h5[color='light'],
      .leshen-typography-h6[color='light'],
      .leshen-typography-body[color='light'] {
        color: ${theme.colors.light.base.hex} !important;
      }

      .reverse {
        @media screen and (min-width: 768px) {
          .split-content__grid {
            grid-template-areas: 'image content' !important;
          }
        }
      }

      .center-children {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .left-align-children {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      .leshen-hero.background-color-default .leshen-price-change span,
      .leshen-hero.background-color-dark .leshen-price-change span,
      .leshen-hero.background-color-primary .leshen-price-change span,
      .leshen-hero.background-color-secondary .leshen-price-change span {
        color: ${theme.colors.white.base.hex} !important;
      }

      .leshen-price-duration {
        font-size: 24px !important;
        align-self: flex-start !important;
        position: relative;
        top: 4px;
      }
    `}
  />
))

export default Globals
